<template>
    <Sidebar v-model:visible="showSidebar" :blockScroll="true" :dismissable="!isLoading" position="right"
        class="member-panel p-sidebar-lg">
        <template #header="slotProps">
            <!-- <p>{{ vehicle.ModelName }}</p>
            <p class="vehicle-page-flow__header-vehicle-trim">{{ vehicle.ModelTrim }}</p> -->
        </template>
        <div class="member-panel__content">
            <div v-if="memberArea == memberAreas.login" class="member-panel__text">
                <p class="member-panel__headline">{{ dictionary.memberLoginHeadline }}</p>
                <p>{{ dictionary.memberLoginText }} <br /><br /></p>
                <p v-if="memberArea == memberAreas.login">Har du ikke oprettet en bruger <a
                        @click="memberArea = memberAreas.create">kan du
                        oprette en her.</a></p>

            </div>
            <div v-if="memberArea == memberAreas.create" class="member-panel__text">
                <p class="member-panel__headline">{{ dictionary.memberCreateHeadline }}</p>
                <p>{{ dictionary.memberCreateText }}<br /><br /></p>
                <p v-if="memberArea == memberAreas.create">Har du allerede en bruger <a
                        @click="memberArea = memberAreas.login">kan du logge ind her.</a></p>
            </div>
            <ResetPasswordMemberForm v-if="memberArea == memberAreas.resetPassword" :dictionary="dictionary"
                :isUserLoggedIn="member != null" @initPasswordReset="handleInitPasswordReset"
                @passwordResetInitialised="handlePasswordResetInitialised"
                @passwordResetDone="memberArea = memberAreas.login" @loading="toggleSpinner" />
            <CreateMemberForm v-if="memberArea == memberAreas.create" :dictionary="dictionary" @created="handleCreated"
                @loading="toggleSpinner" />
            <LoginMemberForm v-if="memberArea == memberAreas.login && member == null" :dictionary="dictionary"
                @loggedIn="handleLoggedIn" @userCreate="memberArea = memberAreas.create"
                @initPasswordReset="handleInitPasswordReset" @loading="toggleSpinner" />
            <MemberMainNavigation v-if="memberArea == memberAreas.menu && member != null" :member="member"
                :dictionary="dictionary" @loggedOut="handleLoggedOut" />
        </div>
    </Sidebar>
    <Toast position="top-center" />
</template>
<script>

import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import Sidebar from 'primevue/sidebar';
import Checkbox from 'primevue/checkbox';
import Toast from 'primevue/toast';
import MemberAreas from './memberAreas';
import CreateMemberForm from './components/createMemberForm.vue';
import LoginMemberForm from './components/loginMemberForm.vue';
import MemberMainNavigation from './components/memberMainNavigation.vue';
import ResetPasswordMemberForm from './components/resetPasswordMemberForm.vue';
import VueHelpers from './vueHelpers';
import CustomEventsNames from '../customEventsNames';
const panelToggleSelector = '.member-panel__toggle';
export default {
    name: "memberPanel",
    components: {
        InputText,
        Button,
        Sidebar,
        Checkbox,
        Toast,
        CreateMemberForm,
        LoginMemberForm,
        MemberMainNavigation,
        ResetPasswordMemberForm
    },
    data() {
        return {
            dictionary: [],
            showSidebar: false,
            isLoading: false,
            memberAreas: null,
            memberArea: null,
            member: null,
        };
    },
    created() {
        const vm = this;
        let dictionaryLoaded = false;

        vm.culture = document.querySelector("html").getAttribute("lang");
        vm.memberAreas = MemberAreas;
        vm.memberArea = vm.memberAreas.login;

        const panelElement = document.querySelector(panelToggleSelector);
        if (panelElement) {
            panelElement.addEventListener('click', e => {
                vm.showSidebar = true;
            });

            panelElement.addEventListener(CustomEventsNames.openUserLoginPanel, e => {
                vm.memberArea = vm.memberAreas.login;
                vm.showSidebar = true;
            });

            panelElement.addEventListener(CustomEventsNames.openUserCreationPanel, e => {
                vm.memberArea = vm.memberAreas.create;
                vm.showSidebar = true;
            });
        }

        fetch('/umbraco/api/resourcesApi/GetMemberDictionary').then((response) => response.json())
            .then((data) => {
                vm.dictionary = data;
                dictionaryLoaded = true;
            })
            .catch((error) => {
                console.log(error);
                dictionaryLoaded = true;
            });

        var iterations = 0;
        var dictionaryLoadedTimer = setInterval(() => {
            if (dictionaryLoaded) {
                clearInterval(dictionaryLoadedTimer);

                if ('URLSearchParams' in window) {
                    var searchParams = new URLSearchParams(window.location.search);
                    if (searchParams.has('showLogin')) {
                        vm.memberArea = vm.memberAreas.login;
                        vm.showSidebar = true;

                        return false;
                    }

                    if (searchParams.has('pwreset')) {
                        vm.memberArea = vm.memberAreas.resetPassword;
                        vm.showSidebar = true;
                        return false;
                    }

                    if (searchParams.has("verify") && searchParams.has("id") && searchParams.has("tkn")) {
                        if (searchParams.get("verify").toLowerCase() == "true") {
                            vm.toggleSpinner(true);

                            const token = window.location.search.substring(window.location.search.indexOf("tkn=") + 4); //Need to get it like this, because UrlSearchParams encodes is wrong
                            const memberId = searchParams.get("id");
                            const likedCars = localStorage.getItem(VueHelpers.favoritesCacheKey);

                            fetch('/umbraco/api/memberapi/VerifyEmail', {
                                method: 'post',
                                headers: {
                                    "Content-Type": "application/json",
                                    "RequestVerificationToken": VueHelpers.getAntiForgeryToken()
                                },
                                body: JSON.stringify({ memberId: memberId, token: token, likedCars: likedCars }),
                            }).then(data => {

                                window.dataLayer.push({
                                    'event': 'create_user_complete'
                                });

                                vm.toggleSpinner(false);
                                localStorage.removeItem(VueHelpers.favoritesCacheKey);
                                vm.$toast.add({ severity: 'success', summary: vm.dictionary.memberEmailConfirmedNotificationTitle, detail: vm.dictionary.memberEmailConfirmedNotificationText, life: 10000 });

                                if (likedCars && likedCars != "") {
                                    vm.$toast.add({ severity: 'success', summary: "Dine biler er gemt!", detail: "Dine likede biler er nu gemt i dine favoritter!", life: 10000 });
                                }
                                vm.memberArea = vm.memberAreas.login;
                                VueHelpers.clearQueryString();
                                return false;
                            }).catch(error => {
                                vm.toggleSpinner(false);
                                vm.$toast.add({ severity: 'error', summary: vm.dictionary.memberGeneralErrorTitle, detail: vm.dictionary.memberGeneralErrorText, life: 10000 });
                                console.log(error);
                            })
                        }

                    }
                }
            } else {
                iterations++;
            }

            //Lets try for 10 seconds
            if (iterations === 100) {
                clearInterval(dictionaryLoadedTimer);
            }

        }, 50);


        fetch('/umbraco/api/memberapi/GetLoggedInMember')
            .then(response => {
                if (response.status == 401) {
                    vm.member = null;
                    vm.memberArea = vm.memberAreas.login;
                    const error = new Error("");
                    error.status = response.status;
                    throw error;
                }
                return response;
            })
            .then(response => response.json())
            .then(data => {
                if (data.id != 0) {
                    vm.member = data;
                    vm.memberArea = vm.memberAreas.menu;
                }
            })
            .catch(error => {
                if (error.status != 401) {
                    vm.$toast.add({ severity: 'error', summary: vm.dictionary.memberGeneralErrorTitle, detail: vm.dictionary.memberGeneralErrorText, life: 10000 });
                    console.log(error);
                }
            });
    },
    methods: {
        handleInitPasswordReset() {
            this.memberArea = this.memberAreas.resetPassword;
        },
        handlePasswordResetInitialised() {
            this.showSidebar = false;
            this.memberArea = this.memberAreas.login;
        },
        handleLoggedIn(member) {
            const redirectUrl = localStorage.getItem(VueHelpers.loginRedirectUrlKey);
            if (redirectUrl) {
                localStorage.removeItem(VueHelpers.loginRedirectUrlKey);
                window.location = redirectUrl;
            } else {
                window.location.reload();
            }
        },
        handleCreated() {
            this.memberArea = this.memberAreas.login;
        },
        handleLoggedOut() {
            this.member = null;
            localStorage.removeItem(VueHelpers.favoritesCacheKey);
            window.location.reload();

        },
        toggleSpinner: function (isLoading) {
            this.isLoading = isLoading;

            const bodyElement = document.querySelector("body");
            if (isLoading) {
                bodyElement.classList.add("is-loading");
            } else {
                bodyElement.classList.remove("is-loading");
            }
        }
    }
};
</script>
